// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
    overflow: hidden;
    position: relative;
    text-align: left;
    border-radius: 0.5rem;
    width: 200px;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    background-color: #fff;
  }
  
  .dismiss {
    position: absolute;
    right: 10px;
    top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem;
    background-color: #fff;
    color: black;
    border: 2px solid #D1D5DB;
    font-size: 1rem;
    font-weight: 300;
    width: 30px;
    height: 30px;
    border-radius: 7px;
    transition: .3s ease;
  }
  
  .dismiss:hover {
    background-color: #ee0d0d;
    border: 2px solid #ee0d0d;
    color: #fff;
  }
  
  .header {
    padding: 1.25rem 1rem 1rem 1rem;
  }
  
  .image {
    display: flex;
    margin-left: auto;
    margin-right: auto;
    background-color: #e2feee;
    flex-shrink: 0;
    justify-content: center;
    align-items: center;
    width: 3rem;
    height: 3rem;
    border-radius: 9999px;
    animation: animate .6s linear alternate-reverse infinite;
    transition: .6s ease;
  }
  
  .image svg {
    color: #0afa2a;
    width: 2rem;
    height: 2rem;
  }
  
  .content {
    margin-top: 0.75rem;
    text-align: center;
  }
  
  .title {
    color: #066e29;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.5rem;
  }
  
  .message {
    margin-top: 0.5rem;
    color: #595b5f;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  
  .actions {
    margin: 0.75rem 1rem;
    display: flex;
    justify-content: center;
  }
  
  .history {
    
    padding: 0.5rem 1rem;
    background-color: #642bff;
    color: #ffffff;
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 500;
    justify-content: center;
    width: 40%;
    border-radius: 0.375rem;
    border: none;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  
  .track {
    display: inline-flex;
    margin-top: 0.75rem;
    padding: 0.5rem 1rem;
    color: #242525;
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 500;
    justify-content: center;
    width: 100%;
    border-radius: 0.375rem;
    border: 1px solid #D1D5DB;
    background-color: #fff;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  
  @keyframes animate {
    from {
      transform: scale(1);
    }
  
    to {
      transform: scale(1.09);
    }
  }
  .cclogo
  {
    height:30px;
    width:30px
  }`, "",{"version":3,"sources":["webpack://./src/components/Card.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;IACZ,qFAAqF;IACrF,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,sBAAsB;IACtB,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,wDAAwD;IACxD,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,aAAa;IACb,uBAAuB;EACzB;;EAEA;;IAEE,oBAAoB;IACpB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,UAAU;IACV,uBAAuB;IACvB,YAAY;IACZ,2CAA2C;EAC7C;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;IACX,uBAAuB;IACvB,yBAAyB;IACzB,sBAAsB;IACtB,2CAA2C;EAC7C;;EAEA;IACE;MACE,mBAAmB;IACrB;;IAEA;MACE,sBAAsB;IACxB;EACF;EACA;;IAEE,WAAW;IACX;EACF","sourcesContent":[".card {\r\n    overflow: hidden;\r\n    position: relative;\r\n    text-align: left;\r\n    border-radius: 0.5rem;\r\n    width: 200px;\r\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\r\n    background-color: #fff;\r\n  }\r\n  \r\n  .dismiss {\r\n    position: absolute;\r\n    right: 10px;\r\n    top: 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 0.5rem 1rem;\r\n    background-color: #fff;\r\n    color: black;\r\n    border: 2px solid #D1D5DB;\r\n    font-size: 1rem;\r\n    font-weight: 300;\r\n    width: 30px;\r\n    height: 30px;\r\n    border-radius: 7px;\r\n    transition: .3s ease;\r\n  }\r\n  \r\n  .dismiss:hover {\r\n    background-color: #ee0d0d;\r\n    border: 2px solid #ee0d0d;\r\n    color: #fff;\r\n  }\r\n  \r\n  .header {\r\n    padding: 1.25rem 1rem 1rem 1rem;\r\n  }\r\n  \r\n  .image {\r\n    display: flex;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    background-color: #e2feee;\r\n    flex-shrink: 0;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 3rem;\r\n    height: 3rem;\r\n    border-radius: 9999px;\r\n    animation: animate .6s linear alternate-reverse infinite;\r\n    transition: .6s ease;\r\n  }\r\n  \r\n  .image svg {\r\n    color: #0afa2a;\r\n    width: 2rem;\r\n    height: 2rem;\r\n  }\r\n  \r\n  .content {\r\n    margin-top: 0.75rem;\r\n    text-align: center;\r\n  }\r\n  \r\n  .title {\r\n    color: #066e29;\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n    line-height: 1.5rem;\r\n  }\r\n  \r\n  .message {\r\n    margin-top: 0.5rem;\r\n    color: #595b5f;\r\n    font-size: 0.875rem;\r\n    line-height: 1.25rem;\r\n  }\r\n  \r\n  .actions {\r\n    margin: 0.75rem 1rem;\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .history {\r\n    \r\n    padding: 0.5rem 1rem;\r\n    background-color: #642bff;\r\n    color: #ffffff;\r\n    font-size: 1rem;\r\n    line-height: 1.5rem;\r\n    font-weight: 500;\r\n    justify-content: center;\r\n    width: 40%;\r\n    border-radius: 0.375rem;\r\n    border: none;\r\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\r\n  }\r\n  \r\n  .track {\r\n    display: inline-flex;\r\n    margin-top: 0.75rem;\r\n    padding: 0.5rem 1rem;\r\n    color: #242525;\r\n    font-size: 1rem;\r\n    line-height: 1.5rem;\r\n    font-weight: 500;\r\n    justify-content: center;\r\n    width: 100%;\r\n    border-radius: 0.375rem;\r\n    border: 1px solid #D1D5DB;\r\n    background-color: #fff;\r\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\r\n  }\r\n  \r\n  @keyframes animate {\r\n    from {\r\n      transform: scale(1);\r\n    }\r\n  \r\n    to {\r\n      transform: scale(1.09);\r\n    }\r\n  }\r\n  .cclogo\r\n  {\r\n    height:30px;\r\n    width:30px\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
